import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/_app/projects')({
  component: () => <Outlet />,
});
